export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://trafikbevakningwebapi-1.onrender.com';
export const AUTOMATION_SERVICE_URL =
  process.env.REACT_APP_AUTOMATION_SERVICE_URL || 'http://16.16.156.182:5001';
